module.exports = __webpack_public_path__ + "static/media/font.e0ca2301.svg";